import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import About from "../common/About";
import Headerstart from "../common/Headerstart";

const AboutPage = () => {
  return (
    <>
      <Header />
      <Headerstart link={"About Us"} />
      <About />
      <Footer />
    </>
  );
};

export default AboutPage;
